__turbopack_context__.v({
  "inner": "EyebrowRibbon-module-scss-module__y0sg2G__inner",
  "isXLarge": "EyebrowRibbon-module-scss-module__y0sg2G__isXLarge",
  "root": "EyebrowRibbon-module-scss-module__y0sg2G__root",
});
